// Mock data for Tu Iglesia App Landing Page

export const heroData = {
  title: "TU IGLESIA APP",
  tagline: "Tu Aliado en el Ministerio de Cristo",
  description: "Somos la primera herramienta completa para gestión de ministerios y congregaciones cristianas.",
  subDescription: "La primera plataforma cristiana en manejar un concepto global de gestión de ministerios, generando módulos y herramientas completamente personalizables para cada congregación.",
  ctaText: "Regístrate Ahora",
  secondaryCta: "Conoce Más",
  appStoreUrl: "#",
  playStoreUrl: "#",
  websiteUrl: "www.tuiglesia.app",
  registroUrl: "https://registro.tuiglesia.app"
};

export const missionVision = {
  mission: {
    title: "Misión",
    text: "Desarrollar herramientas digitales innovadoras para las congregaciones, ministros, ministerios y feligreses cristianos, colaborando a generar mayor eficiencia y rapidez en la expansión del mensaje de Cristo al mundo."
  },
  vision: {
    title: "Visión",
    text: "Liberar el potencial moderno de la evangelización, seguimiento ministerial e integración comunitaria cristiana."
  },
  verse: {
    text: "\"Porque nosotros somos colaboradores de Dios, y vosotros sois labranza de Dios, edificio de Dios.\"",
    reference: "1 Corintios 3:9"
  }
};

export const stats = [
  {
    value: "3x",
    label: "más miembros que la asistencia personal",
    icon: "Users"
  },
  {
    value: "50%",
    label: "más alcance de la palabra",
    icon: "Globe"
  },
  {
    value: "+10%",
    label: "en aportes con pasarela electrónica",
    icon: "TrendingUp"
  }
];

export const features = [
  {
    id: 1,
    title: "Administración",
    description: "Lleva el control de las finanzas, registro de todos los aportes y gastos generados, métricas financieras, promedio de ingresos, análisis por día, hora, tipo de pago y aporte.",
    verse: "\"Su señor le dijo: Bien, buen siervo y fiel; sobre poco has sido fiel, sobre mucho te pondré.\"",
    verseRef: "Mateo 25:23",
    icon: "BarChart3"
  },
  {
    id: 2,
    title: "Aportes y Pasarela",
    description: "Conexión para aportes en línea, tarjetas, depósitos, transferencias, PayPal, Venmo, Binance, Zinli, Criptomonedas, Zelle. Digitaliza los diezmos y ofrendas en 3 sencillos pasos.",
    verse: "\"Cada uno dé como propuso en su corazón: no con tristeza, ni por necesidad, porque Dios ama al dador alegre.\"",
    verseRef: "2 Corintios 9:7",
    icon: "CreditCard"
  },
  {
    id: 3,
    title: "Biblia Integrada",
    description: "Múltiples versiones de la biblia directamente en la app, con concordancias, buscador y guardado de citas bíblicas sin salir de la aplicación.",
    verse: "\"Toda la Escritura es inspirada por Dios, y útil para enseñar, para redargüir, para corregir, para instruir en justicia.\"",
    verseRef: "2 Timoteo 3:16",
    icon: "BookOpen"
  },
  {
    id: 4,
    title: "Medios y Streaming",
    description: "Videos, servicios, conciertos, alabanzas, escuelas, testimoniales, podcasts y transmisión en vivo. Califica, guarda como favoritos, comparte por redes sociales y toma apuntes.",
    verse: "\"Id por todo el mundo y predicad el evangelio a toda criatura.\"",
    verseRef: "Marcos 16:15",
    icon: "Play"
  },
  {
    id: 5,
    title: "Comunidad",
    description: "Mensajería, calendario, cartelera, anuncios, chats, creación de grupos, asignación de cargos y roles. Conexión inmediata con todo el material de medios y sistema de difusión.",
    verse: "\"Permanezca el amor fraternal.\"",
    verseRef: "Hebreos 13:1",
    icon: "Heart"
  },
  {
    id: 6,
    title: "Estudios y Puntos de Fe",
    description: "Cursos, estudios bíblicos, certificaciones, encuestas y actividades. Cada miembro acumula puntos de fe al cumplir metas que pueden usar para compras y beneficios.",
    verse: "\"La fe es por el oír, y el oír, por la palabra de Dios.\"",
    verseRef: "Romanos 10:17",
    icon: "GraduationCap"
  },
  {
    id: 7,
    title: "Oración y Conexión",
    description: "Oración, versículo y disertación diaria, petición de oraciones especiales, mensajería para guía espiritual, con notificaciones para recordatorio.",
    verse: "\"Orad sin cesar.\"",
    verseRef: "1 Tesalonicenses 5:17",
    icon: "HandHeart"
  },
  {
    id: 8,
    title: "Suite Ministerial",
    description: "Todas las herramientas de TU IGLESIA en un solo lugar. Panel centralizado para administrar cada aspecto del ministerio de forma intuitiva e innovadora.",
    verse: "\"Hágase todo decentemente y con orden.\"",
    verseRef: "1 Corintios 14:40",
    icon: "LayoutDashboard"
  }
];

export const pastorBenefits = [
  "Gestión integral de ministerios y congregaciones",
  "Control financiero completo con métricas detalladas",
  "Flujo de trabajo ministerial optimizado",
  "Comunicación directa con toda la congregación",
  "Herramientas de evangelismo y expansión del mensaje",
  "Contenido de medios organizado y transmisión en vivo",
  "Módulos completamente personalizables"
];

export const memberBenefits = [
  "Tu iglesia siempre en tu bolsillo",
  "Acceso a estudios bíblicos y certificaciones",
  "Acumula puntos de fe con beneficios reales",
  "Comunidad conectada: chats, grupos y mensajería",
  "Guía espiritual y oración personalizada",
  "Aporta diezmos y ofrendas en 3 pasos",
  "Biblia integrada con múltiples versiones"
];

export const platforms = [
  {
    title: "Aplicación Móvil",
    description: "TU IGLESIA en el bolsillo de cada uno de sus miembros",
    icon: "Smartphone"
  },
  {
    title: "Tablets",
    description: "Una mejor experiencia del contenido de medios",
    icon: "Tablet"
  },
  {
    title: "Smart TVs",
    description: "Disfruta servicios y contenido en pantalla grande",
    icon: "Monitor"
  }
];

export const expandBenefits = [
  "Mejora el alcance a tu congregación",
  "Encausa el flujo de trabajo ministerial",
  "Experiencias y contenido personalizables",
  "Conecta con tus miembros cuando más lo necesiten"
];

export const navLinks = [
  { label: "Inicio", href: "#hero" },
  { label: "Características", href: "#features" },
  { label: "Pastores", href: "#pastors" },
  { label: "Alabanzas", href: "#alabanzas" },
  { label: "Miembros", href: "#members" },
  { label: "Plataformas", href: "#platforms" }
];

export const footerData = {
  brand: "Tu Iglesia App",
  tagline: "Tu aliado en el Ministerio de Cristo",
  website: "www.tuiglesia.app",
  verse: {
    text: "\"Por tanto, mirad por vosotros, y por todo el rebaño en que el Espíritu Santo os ha puesto por obispos, para apacentar la iglesia del Señor.\"",
    reference: "Hechos 20:28"
  },
  socialLinks: [
    { name: "Facebook", icon: "Facebook" },
    { name: "Instagram", icon: "Instagram" },
    { name: "YouTube", icon: "Youtube" },
    { name: "Twitter", icon: "Twitter" }
  ]
};

export const images = {
  hero: "https://images.unsplash.com/photo-1760367120244-8db5e65191a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxjaHVyY2glMjBjb21tdW5pdHklMjB3b3JzaGlwfGVufDB8fHx8MTc3MDY4NDExMHww&ixlib=rb-4.1.0&q=85",
  community: "https://images.unsplash.com/photo-1760367120345-2b96c53de838?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxjaHVyY2glMjBjb21tdW5pdHklMjB3b3JzaGlwfGVufDB8fHx8MTc3MDY4NDExMHww&ixlib=rb-4.1.0&q=85",
  congregation: "https://images.unsplash.com/photo-1761477075702-138de1cb7fff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjaHJpc3RpYW4lMjBjb25ncmVnYXRpb24lMjBtb2Rlcm58ZW58MHx8fHwxNzcwNjg0MTE1fDA&ixlib=rb-4.1.0&q=85",
  modern: "https://images.unsplash.com/photo-1765947382559-93260e5d6c89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxjaHJpc3RpYW4lMjBjb25ncmVnYXRpb24lMjBtb2Rlcm58ZW58MHx8fHwxNzcwNjg0MTE1fDA&ixlib=rb-4.1.0&q=85",
  prayer: "https://images.unsplash.com/photo-1555817128-342e1c8b3101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxwZW9wbGUlMjBwcmF5aW5nJTIwdG9nZXRoZXJ8ZW58MHx8fHwxNzcwNjg0MTIwfDA&ixlib=rb-4.1.0&q=85",
  worship: "https://images.unsplash.com/photo-1729089049653-24312fdca908?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwZW9wbGUlMjBwcmF5aW5nJTIwdG9nZXRoZXJ8ZW58MHx8fHwxNzcwNjg0MTIwfDA&ixlib=rb-4.1.0&q=85",
  logoDark: "/logo-dark.png",
  logoBlue: "/logo-blue.png",
  logoWhite: "/logo-white.png"
};
